import * as React from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import CommonContext from '../CommonContext'
import ResourcesOverview from './ResourcesOverview'

type ResourcesOverviewAppProps = {
  startDate: string
  endDate: string
  availableDepartments: any[]
  availablePartners: any[]
  availableUsers: any[]
  currentUser: any
}

export default function ResourcesOverviewApp(props: ResourcesOverviewAppProps) {
  const { startDate, endDate, availableDepartments, availablePartners, availableUsers, currentUser } = props
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: false,
      },
    },
  })

  const dictionaries = {
    availableDepartments,
    availablePartners,
    availableUsers,
    currentUser,
  }

  return (
    <CommonContext.Provider value={dictionaries}>
      <QueryClientProvider client={queryClient}>
        <ResourcesOverview startDate={startDate} endDate={endDate} />
      </QueryClientProvider>
    </CommonContext.Provider>
  )
}
